import { Link } from "react-router-dom"


export const Breadcrumb = ({ routes }) => {
    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb text-sm">
                {routes?.map(route => {
                    if (!route.active) {
                        return (
                            <li className="breadcrumb-item" key={route.id}>
                                <Link to={route.link}>{route.name}</Link>
                            </li>
                        )
                    } else {
                        return (
                            <li className="breadcrumb-item" aria-current="page" key={route.id}>{route.name}</li>
                        )
                    }
                })}
            </ol>
        </nav>
    )
}